module.exports = __webpack_public_path__ + "static/media/search.371d8f0f.svg";